import { inject, Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';

import { CanActivateAsync } from '@plugins/client/routing/types';

import { DataService } from '../services';

@Injectable({ providedIn: 'root' })
export class InstanceGuard implements CanActivateAsync {
  readonly #dataService = inject(DataService);

  canActivate(): Observable<boolean> {
    if (this.#dataService.instance()) {
      return of(true);
    }
    return this.#dataService.fetchInstance().pipe(map(() => true));
  }
}
